import React, { useState, VoidFunctionComponent } from 'react';

interface Props {
  inputList: {
    id: string,
    label: string;
  }[],
  placeholder: string;
  callBack?: any;
  value?: string;
}
export const Select: VoidFunctionComponent<Props> = ({
  inputList,
  value = "",
  callBack,
  placeholder,
}) => {
  const [selected, setSelected] = useState(value);

  return (
    <div
      className="select"
    >
      <select
        onChange={(e) => {
          setSelected(e.target.value);
          callBack(e.target.value);
        }}
        value={selected || undefined}
      >
        <option selected disabled style={{ display: 'none' }}>{placeholder}</option>
        {
          inputList.map(i =>
            <option key={i.id} value={i.id}>{i.label}</option>)
        }
      </select>
    </div>
  )
}